import { render, staticRenderFns } from "./Flatfinder.vue?vue&type=template&id=634670ad&"
import script from "./Flatfinder.vue?vue&type=script&lang=js&"
export * from "./Flatfinder.vue?vue&type=script&lang=js&"
import style0 from "./Flatfinder.vue?vue&type=style&index=0&id=634670ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports